import script from "./CouponDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponDialog.vue?vue&type=script&setup=true&lang=js"

import "./CouponDialog.vue?vue&type=style&index=0&id=f42d9ee4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f42d9ee4"]])

export default __exports__